"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResolveLocalizedStringFactory = void 0;
const assert_1 = require("tsafe/assert");
const is_1 = require("tsafe/is");
const noUndefined_1 = require("tsafe/noUndefined");
/** Note react as dependency injection */
function createResolveLocalizedStringFactory(params) {
    const { createJsxElement } = params;
    function createResolveLocalizedString(params) {
        const { currentLanguage, fallbackLanguage, labelWhenMismatchingLanguage = false } = params;
        function resolveLocalizedStringDetailed(localizedString) {
            var _a;
            if (typeof localizedString === "string") {
                const { ifStringAssumeLanguage } = typeof labelWhenMismatchingLanguage === "object"
                    ? labelWhenMismatchingLanguage
                    : { ifStringAssumeLanguage: fallbackLanguage };
                if (currentLanguage === ifStringAssumeLanguage) {
                    return {
                        "str": localizedString,
                        "langAttrValue": undefined
                    };
                }
                return {
                    "str": localizedString,
                    "langAttrValue": ifStringAssumeLanguage
                };
            }
            localizedString = (0, noUndefined_1.noUndefined)(localizedString);
            {
                const text = localizedString[currentLanguage];
                if (typeof text === "string") {
                    return {
                        "str": text,
                        "langAttrValue": undefined
                    };
                }
            }
            {
                const text = localizedString[fallbackLanguage];
                if (typeof text === "string") {
                    return {
                        "str": text,
                        "langAttrValue": fallbackLanguage
                    };
                }
            }
            const [lang, text] = (_a = Object.entries(localizedString)[0]) !== null && _a !== void 0 ? _a : [];
            (0, assert_1.assert)(typeof text === "string", "Must contain at least one value");
            (0, assert_1.assert)((0, is_1.is)(lang));
            return {
                "str": text,
                "langAttrValue": lang
            };
        }
        function resolveLocalizedString(localizedString) {
            const { str, langAttrValue } = resolveLocalizedStringDetailed(localizedString);
            return labelWhenMismatchingLanguage !== false
                ? createJsxElement({ "text": str, "lang": langAttrValue })
                : str;
        }
        return { resolveLocalizedString, resolveLocalizedStringDetailed };
    }
    return { createResolveLocalizedString };
}
exports.createResolveLocalizedStringFactory = createResolveLocalizedStringFactory;
